module.exports = __webpack_public_path__ + "assets/img/travel-day46.6368be63.png";